import { render, staticRenderFns } from "./SignerList.vue?vue&type=template&id=2daafdf8&scoped=true&"
import script from "./SignerList.vue?vue&type=script&lang=js&"
export * from "./SignerList.vue?vue&type=script&lang=js&"
import style0 from "./SignerList.vue?vue&type=style&index=0&id=2daafdf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daafdf8",
  null
  
)

export default component.exports